module.exports = __webpack_public_path__ + "static/img/y4.34a61d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y4.jpg
// module id = d/b8
// module chunks = 1